export const getAuthToken = () => localStorage.getItem("accessToken") || "";

export const isAuthenticated = () => Boolean(getAuthToken());

export const clearAuth = () => {
  localStorage.removeItem("accessToken");
};
